import { ROUTES } from "./appRoutes";

const PROTOCOL_PATTERN = /^[a-zA-Z][a-zA-Z\d+.-]*:/;
const AUTH_PATHS = new Set([
  ROUTES.LOGIN,
  ROUTES.REGISTER,
  ROUTES.CONFIRM,
  ROUTES.FORGOT_PASSWORD,
  ROUTES.RESET_PASSWORD,
]);

export const sanitizeInternalPath = (value) => {
  if (typeof value !== "string") return null;

  const trimmed = value.trim();
  if (!trimmed) return null;
  if (trimmed.startsWith("//")) return null;
  if (PROTOCOL_PATTERN.test(trimmed)) return null;

  const candidate = trimmed.startsWith("/") ? trimmed : `/${trimmed}`;

  try {
    const baseOrigin =
      typeof window !== "undefined" && window.location?.origin
        ? window.location.origin
        : "http://localhost";
    const parsed = new URL(candidate, baseOrigin);

    if (typeof window !== "undefined" && parsed.origin !== window.location.origin) {
      return null;
    }

    if (!parsed.pathname.startsWith("/")) return null;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch (_) {
    return null;
  }
};

export const getCurrentAppPath = (locationLike) => {
  const pathname = locationLike?.pathname || ROUTES.HOME;
  const search = locationLike?.search || "";
  const hash = locationLike?.hash || "";
  return sanitizeInternalPath(`${pathname}${search}${hash}`) || ROUTES.HOME;
};

export const getPostAuthFallbackPath = (locationLike) => {
  const pathname = sanitizeInternalPath(locationLike?.pathname || ROUTES.HOME) || ROUTES.HOME;
  if (AUTH_PATHS.has(pathname)) return ROUTES.HOME;
  return getCurrentAppPath(locationLike);
};

export const buildAuthPathWithNext = (authPath, nextPath) => {
  const safeAuthPath = sanitizeInternalPath(authPath) || ROUTES.LOGIN;
  const safeNext = sanitizeInternalPath(nextPath);

  if (!safeNext || safeNext === ROUTES.HOME) return safeAuthPath;

  const params = new URLSearchParams({ next: safeNext });
  return `${safeAuthPath}?${params.toString()}`;
};

export const getSafeNextFromLocation = (locationLike, fallback = ROUTES.HOME) => {
  const searchParams = new URLSearchParams(locationLike?.search || "");
  const queryNext = searchParams.get("next");
  const stateNext = locationLike?.state?.next;

  const safeQueryNext = sanitizeInternalPath(queryNext);
  if (safeQueryNext) return safeQueryNext;

  const safeStateNext = sanitizeInternalPath(stateNext);
  if (safeStateNext) return safeStateNext;

  return sanitizeInternalPath(fallback) || ROUTES.HOME;
};
